import loki from 'lokijs';

let db = new loki("signlabs", {env: "BROWSER"});
let collections = [
  {
    name: "products",
    props: {
      indices: ['id']
    }
  },
  {
    name: "materials",
    props: {
      indices: ['id']
    }
  },
  {
    name: "colors",
    props: {
      indices: ['id']
    }
  },
  {
    name: "shapes",
    props: {
      indices: ['id']
    }
  },
  {
    name: "fonts",
    props: {
      indices: ['id']
    }
  },
  {
    name: "fix_methods",
    props: {
      indices: ['id']
    }
  }
];
collections.forEach((collection) => db.addCollection(collection.name, collection.props));
window.db = db;
export default function dbFactory() {
  return db;
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/services/loki.factory.js
 **/